import { AssignmentsStateType } from '../types';
import { createStandardAction } from 'typesafe-actions';

export const setAssignmentsClassId = createStandardAction(
  'ASSIGNMENTS/SET_CLASSID'
)<AssignmentsStateType>();
